import { FilterOperator, FilterType, UnitOfTime, } from '../../../../types/filter';
const allTypes = (argumentCount) => ({
    [FilterType.BOOLEAN]: argumentCount,
    [FilterType.STRING]: argumentCount,
    [FilterType.NUMBER]: argumentCount,
    [FilterType.DATE]: argumentCount,
});
const unsupportedTypes = {
    [FilterType.BOOLEAN]: null,
    [FilterType.STRING]: null,
    [FilterType.NUMBER]: null,
    [FilterType.DATE]: null,
};
const stringOperators = [
    FilterOperator.STARTS_WITH,
    FilterOperator.ENDS_WITH,
    FilterOperator.INCLUDE,
    FilterOperator.NOT_INCLUDE,
];
const comparisonOperators = [
    FilterOperator.LESS_THAN,
    FilterOperator.LESS_THAN_OR_EQUAL,
    FilterOperator.GREATER_THAN,
    FilterOperator.GREATER_THAN_OR_EQUAL,
];
export const filterExpressionRelativeDateOperators = [
    FilterOperator.IN_THE_PAST,
    FilterOperator.NOT_IN_THE_PAST,
    FilterOperator.IN_THE_NEXT,
];
export const isFilterExpressionRelativeDateOperator = (operator) => filterExpressionRelativeDateOperators.some((relativeDateOperator) => relativeDateOperator === operator);
const currentDateOperators = [
    FilterOperator.IN_THE_CURRENT,
    FilterOperator.NOT_IN_THE_CURRENT,
];
export const filterExpressionDateUnits = [
    UnitOfTime.days,
    UnitOfTime.weeks,
    UnitOfTime.months,
    UnitOfTime.quarters,
    UnitOfTime.years,
];
export const filterExpressionOperatorDefinitions = [
    {
        operator: FilterOperator.NULL,
        syntax: 'presence',
        argumentSyntax: 'none',
        argumentCountByFilterType: allTypes(0),
    },
    {
        operator: FilterOperator.NOT_NULL,
        syntax: 'presence',
        argumentSyntax: 'none',
        argumentCountByFilterType: allTypes(0),
    },
    {
        operator: FilterOperator.EQUALS,
        syntax: 'values',
        argumentSyntax: 'values',
        argumentCountByFilterType: {
            [FilterType.BOOLEAN]: 1,
            [FilterType.STRING]: 'oneOrMore',
            [FilterType.NUMBER]: 'oneOrMore',
            [FilterType.DATE]: 'oneOrMore',
        },
    },
    {
        operator: FilterOperator.NOT_EQUALS,
        syntax: 'values',
        argumentSyntax: 'values',
        argumentCountByFilterType: {
            [FilterType.BOOLEAN]: 1,
            [FilterType.STRING]: 'oneOrMore',
            [FilterType.NUMBER]: 'oneOrMore',
            [FilterType.DATE]: 'oneOrMore',
        },
    },
    ...stringOperators.map((operator) => ({
        operator,
        syntax: 'values',
        argumentSyntax: 'values',
        argumentCountByFilterType: {
            ...unsupportedTypes,
            [FilterType.STRING]: 'oneOrMore',
        },
    })),
    ...comparisonOperators.map((operator) => ({
        operator,
        syntax: 'values',
        argumentSyntax: 'values',
        argumentCountByFilterType: {
            ...unsupportedTypes,
            [FilterType.NUMBER]: 1,
            [FilterType.DATE]: 1,
        },
    })),
    ...filterExpressionRelativeDateOperators.map((operator) => ({
        operator,
        syntax: 'values',
        argumentSyntax: 'relativeDate',
        argumentCountByFilterType: {
            ...unsupportedTypes,
            [FilterType.DATE]: 1,
        },
    })),
    ...currentDateOperators.map((operator) => ({
        operator,
        syntax: 'values',
        argumentSyntax: 'currentDate',
        argumentCountByFilterType: {
            ...unsupportedTypes,
            [FilterType.DATE]: 1,
        },
    })),
    {
        operator: FilterOperator.IN_BETWEEN,
        syntax: 'values',
        argumentSyntax: 'values',
        argumentCountByFilterType: {
            ...unsupportedTypes,
            [FilterType.NUMBER]: 2,
            [FilterType.DATE]: 2,
        },
    },
    {
        operator: FilterOperator.NOT_IN_BETWEEN,
        syntax: 'values',
        argumentSyntax: 'values',
        argumentCountByFilterType: {
            ...unsupportedTypes,
            [FilterType.NUMBER]: 2,
        },
    },
];
export const filterExpressionOperators = filterExpressionOperatorDefinitions.map(({ operator }) => operator);
export const isFilterExpressionOperator = (value) => filterExpressionOperatorDefinitions.some(({ operator }) => operator === value);
//# sourceMappingURL=operators.js.map